import { render, staticRenderFns } from "./EditarDatos.vue?vue&type=template&id=f0ed5780&scoped=true"
import script from "./EditarDatos.vue?vue&type=script&lang=js"
export * from "./EditarDatos.vue?vue&type=script&lang=js"
import style0 from "./EditarDatos.vue?vue&type=style&index=0&id=f0ed5780&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ed5780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0ed5780')) {
      api.createRecord('f0ed5780', component.options)
    } else {
      api.reload('f0ed5780', component.options)
    }
    module.hot.accept("./EditarDatos.vue?vue&type=template&id=f0ed5780&scoped=true", function () {
      api.rerender('f0ed5780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/EditarDatos.vue"
export default component.exports